import { useState } from "react";
import HeroSection from "@/components/landing/HeroSection";
import RiskSection from "@/components/landing/RiskSection";
import DifferenceSection from "@/components/landing/DifferenceSection";
import WhatIsSection from "@/components/landing/WhatIsSection";
import HowWorksSection from "@/components/landing/HowWorksSection";
import BenefitsSection from "@/components/landing/BenefitsSection";
import DifferentialsSection from "@/components/landing/DifferentialsSection";
import ValidationSection from "@/components/landing/ValidationSection";
import CostSection from "@/components/landing/CostSection";
import TrialProcessSection from "@/components/landing/TrialProcessSection";
import ActivationProcessSection from "@/components/landing/ActivationProcessSection";
import LicenseContractSection from "@/components/landing/LicenseContractSection";
import PricingSection from "@/components/landing/PricingSection";
import SecuritySection from "@/components/landing/SecuritySection";
import CompanySection from "@/components/landing/CompanySection";
import FAQSection from "@/components/landing/FAQSection";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import LeadFormModal from "@/components/landing/LeadFormModal";
import Navigation from "@/components/landing/Navigation";

export default function LandingPage() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#0F1115]" data-testid="landing-page">
      <Navigation onOpenForm={() => setIsFormOpen(true)} />
      
      <main>
        <HeroSection onOpenForm={() => setIsFormOpen(true)} />
        <RiskSection />
        <BenefitsSection />
        <DifferenceSection />
        <WhatIsSection />
        <HowWorksSection />
        <DifferentialsSection />
        <TrialProcessSection onOpenForm={() => setIsFormOpen(true)} />
        <ValidationSection />
        <CostSection />
        <ActivationProcessSection />
        <LicenseContractSection />
        <PricingSection onOpenForm={() => setIsFormOpen(true)} />
        <SecuritySection />
        <CompanySection />
        <FAQSection />
        <ContactSection />
      </main>

      <Footer />

      <LeadFormModal 
        isOpen={isFormOpen} 
        onClose={() => setIsFormOpen(false)} 
      />
    </div>
  );
}
